import { call, select, put } from 'redux-saga/effects';
import i18next from 'i18next';
import { PapiError } from '@wix/da-papi-types';
import { XhrResponse } from '@wix/da-http-client';
import { getCurrentUser } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { getPresence } from '../selectors/room';
import { getDrawerActiveFilter } from '../selectors/drawer';
import { getDrawerStreamId } from '../helpers';
import {
  withCursor,
  selectors as streamSelectors,
} from '@wix/da-shared-react/pkg/Stream';
import { RoomItem } from '../../types';

export function* getChatters(room_id: string) {
  const presence = yield select(state => getPresence(state, room_id));
  const currentUser = yield select(state => getCurrentUser(state));

  const chatters = Object.keys(presence);
  const allChatters = [currentUser.useridUuid, ...chatters];

  return allChatters;
}

/** looks in the response for:
 *    - an errorDescription: defaulting to 'unknown error'
 *    - and/or errorDetails?.errorKey: defaulting to
 *      damz.saga.roomManagement.error.${handlerName}
 *  and combines them into a single string for a notif
 */
export function getErrorTextFromResponse(
  handlerName: string,
  response: XhrResponse<any>
): string {
  const errorDescription =
    (response as PapiError)?.errorDescription ?? 'unknown error';
  const errorKey =
    (response as PapiError)?.errorDetails?.errorKey ??
    `damz:damz.saga.roomManagement.error.${handlerName}`;
  return i18next.t(errorKey, { errorDescription });
}

export function* moveItemsToStreamHead(streamId: string, items: RoomItem[]) {
  yield put(
    withCursor.actions.deleteItems({
      streamId,
      items,
      doNotUpdateNextOffset: true,
      isEqual: (item1: RoomItem, item2: RoomItem) =>
        item1.room.room_id === item2.room.room_id,
    })
  );
  yield put(
    withCursor.actions.insertItemsAtOffsetAndSetCursor({
      streamId,
      items,
      offset: 0,
    })
  );
}

export function* moveRoomToDrawerHead(roomId: string) {
  const filter = yield select(getDrawerActiveFilter);
  const streamId = getDrawerStreamId(filter);
  const currentItems: RoomItem[] = yield select(
    streamSelectors.getItems,
    streamId
  );
  const matchingItem = currentItems.find(item => item.room.room_id === roomId);
  if (matchingItem) {
    yield call(moveItemsToStreamHead, streamId, [matchingItem]);
  }
}

/**
 * Checks if user is online and shows error notification if offline
 * TODO turns of navigator.onLine is randomly incorrect, need to do http request to verify
 * @returns true if online, false if offline
 */
export function* checkUserOnlineStateAndError() {
  /* if (!navigator.onLine) {
    yield put(
      addErrorNotification(i18next.t('damz:damz.error.send.failed.offline'))
    );
    return false;
  }*/
  return true;
}
